import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { CollectionPreview, GetCollectionPreviewResponse } from "@apiserver-rest/ponder-data-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { CollectionPreviewComponent } from "./collection-preview.component";

@Component({
    selector: "collection-previews",
    imports: [LoadingComponent, CollectionPreviewComponent],
    templateUrl: "./collection-previews.component.html"
})
export class CollectionPreviewsComponent {
    @Input({ required: true }) public username!: string;

    public isVisible: boolean = true;
    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;
    public collections: CollectionPreview[] = [];

    constructor(private ponderDataClient: PonderDataClient) {
        
    }

    public ngOnInit(): void {
        this.ponderDataClient.collectionPreview(this.username).subscribe({
            next: (response: GetCollectionPreviewResponse) => {
                if (response.success) {
                    this.collections = response.collections?.sort((a, b) => (b.valueUSD - a.valueUSD)) ?? [];
                    this.loadingSuccess = true;
                }
                
                this.isVisible = response.isVisible;
            }
        }).add(() => { this.isLoading = false; })
    }
}